import { useMemo } from 'react'

import useABTestValue from '@hooks/useABTestValue'

export type Step = 'welcome' | 'app' | 'newsletter' | 'highlights'

export type UseBlickPlusOnboardingStepsABTest = () => Step[] | undefined

const useBlickPlusOnboardingStepsABTest: UseBlickPlusOnboardingStepsABTest =
  () => {
    const onboardingStepsOrder = useABTestValue('onboardingStepsOrder')

    return useMemo<Step[] | undefined>(() => {
      if (!onboardingStepsOrder?.trim()) {
        return
      }

      return onboardingStepsOrder.split(',') as Step[]
    }, [onboardingStepsOrder])
  }

export default useBlickPlusOnboardingStepsABTest
